import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import { DATA_METRIC_DATA, DATA_METRIC_MODE, DATA_METRIC_NAME, DATA_METRIC_ONCE, DATA_METRIC_THRESHOLD } from "../consts";
export var getMetricAttrs = function getMetricAttrs(element) {
  return {
    name: (element === null || element === void 0 ? void 0 : element.getAttribute(DATA_METRIC_NAME)) || '',
    viewportOnce: (element === null || element === void 0 ? void 0 : element.getAttribute(DATA_METRIC_ONCE)) === 'true',
    viewportThreshold: Number(element === null || element === void 0 ? void 0 : element.getAttribute(DATA_METRIC_THRESHOLD)) || 1,
    mode: element === null || element === void 0 ? void 0 : element.getAttribute(DATA_METRIC_MODE),
    data: (element === null || element === void 0 ? void 0 : element.getAttribute(DATA_METRIC_DATA)) || ''
  };
};
export var getMetricNodes = function getMetricNodes(node) {
  return [].concat(_toConsumableArray('hasAttribute' in node && node.hasAttribute(DATA_METRIC_NAME) ? [node] : []), _toConsumableArray(Array.from(node.querySelectorAll("[".concat(DATA_METRIC_NAME, "]")))));
};